import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StudentInfoContentV1 from '../../../student/StudentInfoContentV1';
import StudentInfoContentV2 from '../../../student/StudentInfoContentV2';
import VersionSwitcher from '../../../subcomponents/VersionSwitcher';
import { fetchStudentInfoSettings } from '../searchStudentSlice';

export default function SearchStudentInfoTab() {
    const dispatch = useDispatch();

    const { searchStudent } = useSelector((state) => state.search.student);

    useEffect(() => {
        dispatch(fetchStudentInfoSettings());
    }, [dispatch]);

    return (
        <Box>
            <VersionSwitcher
                content1={
                    <StudentInfoContentV1 content={searchStudent?.studentData} employeeMode />
                }
                content2={
                    <StudentInfoContentV2 content={searchStudent?.studentData} employeeMode />
                }
            />
        </Box>
    );
}
